import React from "react";

export const Costumization = () => {
  return (
    <svg
      className="min-w-[370px] w-[95%] md:w-[520px] md:h-[240px]"
      width="642"
      height="254"
      viewBox="0 0 642 254"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_905_4283)">
        <rect width="642" height="254" rx="13" fill="white" />
        <mask
          id="mask0_905_4283"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="-65"
          width="641"
          height="385"
        >
          <rect
            y="-65"
            width="641"
            height="385"
            fill="url(#paint0_radial_905_4283)"
          />
        </mask>
        <g mask="url(#mask0_905_4283)">
          <circle opacity="0.64" cx="9" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="25" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="41" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="57" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="73" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.47" cx="89" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="105" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.96" cx="121" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="137" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.82" cx="153" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="169" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="185" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="201" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="217" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="233" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="249" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="265" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="281" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.15" cx="297" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="313" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="329" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="345" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="361" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="377" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="393" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="409" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="425" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="441" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="457" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="473" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="489" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.64" cx="505" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="521" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.46" cx="537" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="553" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="569" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="585" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="601" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="617" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="633" cy="8" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="9" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="25" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="41" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="57" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="73" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="89" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="105" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="121" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="137" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="153" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="169" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="185" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="201" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="217" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="233" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="249" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="265" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="281" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="297" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.3" cx="313" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="329" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="345" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="361" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="377" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="393" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.15" cx="409" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="425" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="441" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="457" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="473" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="489" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="505" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="521" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="537" cy="24" r="4" fill="#E8CEF3" />
          <circle cx="553" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="569" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="585" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="601" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.96" cx="617" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.75" cx="633" cy="24" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="9" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="25" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.35" cx="41" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="57" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="73" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="89" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="105" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.63" cx="121" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="137" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.46" cx="153" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="169" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="185" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="201" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="217" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="233" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="249" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="265" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="281" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.58" cx="297" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="313" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.43" cx="329" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="345" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="361" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="377" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="393" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="409" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="425" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="441" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="457" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="473" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="489" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="505" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="521" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="537" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="553" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="569" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="585" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.43" cx="601" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="617" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="633" cy="40" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="9" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="25" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="41" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="57" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="73" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="89" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="105" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="121" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="137" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="153" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.39" cx="169" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="185" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.58" cx="201" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="217" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.1" cx="233" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="249" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="265" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="281" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.42" cx="297" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="313" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.63" cx="329" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="345" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="361" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="377" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.58" cx="393" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="409" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.64" cx="425" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.64" cx="441" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="457" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="473" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="489" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="505" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="521" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="537" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="553" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="569" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="585" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="601" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="617" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="633" cy="56" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="9" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="25" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="41" cy="72" r="4" fill="#E8CEF3" />
          <circle cx="57" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="73" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="89" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="105" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="121" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="137" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="153" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="169" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="185" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="201" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="217" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="233" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.66" cx="249" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="265" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="281" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="297" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="313" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="329" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="345" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="361" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.68" cx="377" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="393" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="409" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="425" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="441" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="457" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="473" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="489" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="505" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.82" cx="521" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="537" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="553" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="569" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.67" cx="585" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="601" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="617" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="633" cy="72" r="4" fill="#E8CEF3" />
          <circle opacity="0.63" cx="9" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="25" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="41" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="57" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="73" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="89" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="105" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="121" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="137" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="153" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="169" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.15" cx="185" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.89" cx="201" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="217" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="233" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="249" cy="88" r="4" fill="#E8CEF3" />
          <circle cx="265" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.71" cx="281" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="297" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="313" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="329" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.95" cx="345" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="361" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.1" cx="377" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="393" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="409" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="425" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="441" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="457" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="473" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="489" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.35" cx="505" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="521" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.17" cx="537" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="553" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="569" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="585" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="601" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="617" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="633" cy="88" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="9" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="25" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="41" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="57" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="73" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="89" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="105" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="121" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="137" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="153" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.89" cx="169" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.48" cx="185" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="201" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="217" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="233" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="249" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="265" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="281" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="297" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="313" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="329" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.89" cx="345" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="361" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="377" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="393" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="409" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="425" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="441" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.63" cx="457" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="473" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="489" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="505" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="521" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="537" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="553" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="569" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="585" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="601" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="617" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.68" cx="633" cy="104" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="9" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="25" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="41" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="57" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="73" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="89" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="105" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="121" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="137" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.46" cx="153" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="169" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="185" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="201" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="217" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.95" cx="233" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="249" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="265" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.94" cx="281" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="297" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="313" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="329" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="345" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="361" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="377" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="393" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="409" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="425" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="441" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="457" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="473" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.39" cx="489" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="505" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.31" cx="521" cy="120" r="4" fill="#E8CEF3" />
          <circle cx="537" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="553" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.59" cx="569" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="585" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="601" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="617" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="633" cy="120" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="9" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.39" cx="25" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.75" cx="41" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="57" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="73" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="89" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="105" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="121" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="137" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="153" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="169" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="185" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="201" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="217" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="233" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.54" cx="249" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.6" cx="265" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="281" cy="136" r="4" fill="#E8CEF3" />
          <circle cx="297" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.15" cx="313" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.67" cx="329" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="345" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.3" cx="361" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="377" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="393" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="409" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="425" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="441" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="457" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="473" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="489" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.35" cx="505" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="521" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="537" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="553" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="569" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.59" cx="585" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.59" cx="601" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="617" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="633" cy="136" r="4" fill="#E8CEF3" />
          <circle opacity="0.48" cx="9" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="25" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.67" cx="41" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.95" cx="57" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.54" cx="73" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="89" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.82" cx="105" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="121" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="137" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="153" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="169" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="185" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="201" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="217" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="233" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.47" cx="249" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="265" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="281" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.9" cx="297" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="313" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="329" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="345" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="361" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="377" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="393" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="409" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="425" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="441" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.58" cx="457" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="473" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="489" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.95" cx="505" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="521" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="537" cy="152" r="4" fill="#E8CEF3" />
          <circle cx="553" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="569" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="585" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="601" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="617" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="633" cy="152" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="9" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="25" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="41" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="57" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="73" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="89" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="105" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="121" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.59" cx="137" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="153" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.35" cx="169" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="185" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="201" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="217" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="233" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.3" cx="249" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="265" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.39" cx="281" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="297" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="313" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.54" cx="329" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="345" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="361" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="377" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="393" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="409" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="425" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="441" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="457" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="473" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="489" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="505" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="521" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="537" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="553" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="569" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.3" cx="585" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.43" cx="601" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="617" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="633" cy="168" r="4" fill="#E8CEF3" />
          <circle opacity="0.48" cx="9" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="25" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="41" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="57" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="73" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="89" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.43" cx="105" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="121" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="137" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="153" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="169" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="185" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="201" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.82" cx="217" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.44" cx="233" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.17" cx="249" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.59" cx="265" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.48" cx="281" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="297" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="313" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="329" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="345" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.42" cx="361" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="377" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="393" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="409" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.82" cx="425" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="441" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="457" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.69" cx="473" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="489" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="505" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="521" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.44" cx="537" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="553" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.64" cx="569" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="585" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="601" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="617" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="633" cy="184" r="4" fill="#E8CEF3" />
          <circle opacity="0.88" cx="9" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="25" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="41" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="57" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.47" cx="73" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="89" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.34" cx="105" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="121" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="137" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="153" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="169" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="185" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.99" cx="201" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="217" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="233" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="249" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.45" cx="265" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="281" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="297" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="313" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="329" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="345" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="361" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="377" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="393" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="409" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="425" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.17" cx="441" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="457" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="473" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.95" cx="489" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="505" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="521" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.47" cx="537" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="553" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.94" cx="569" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="585" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="601" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.12" cx="617" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.31" cx="633" cy="200" r="4" fill="#E8CEF3" />
          <circle opacity="0.46" cx="9" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="25" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.23" cx="41" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.54" cx="57" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="73" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="89" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="105" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="121" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.4" cx="137" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="153" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="169" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="185" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="201" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="217" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="233" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="249" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.97" cx="265" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.71" cx="281" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="297" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="313" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="329" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="345" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.57" cx="361" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="377" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.16" cx="393" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="409" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.5" cx="425" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.96" cx="441" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.39" cx="457" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.19" cx="473" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.74" cx="489" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="505" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.84" cx="521" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="537" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.46" cx="553" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.83" cx="569" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="585" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="601" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="617" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="633" cy="216" r="4" fill="#E8CEF3" />
          <circle opacity="0.51" cx="9" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.87" cx="25" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="41" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="57" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.55" cx="73" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="89" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="105" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.94" cx="121" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.85" cx="137" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="153" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="169" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.8" cx="185" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.17" cx="201" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="217" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.92" cx="233" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.44" cx="249" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.81" cx="265" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="281" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.52" cx="297" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="313" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.86" cx="329" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.91" cx="345" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="361" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="377" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="393" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.64" cx="409" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.13" cx="425" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="441" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.29" cx="457" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.37" cx="473" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.67" cx="489" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.18" cx="505" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.25" cx="521" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.17" cx="537" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="553" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.89" cx="569" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.54" cx="585" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.22" cx="601" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.35" cx="617" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.24" cx="633" cy="232" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="9" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.61" cx="25" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="41" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.28" cx="57" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="73" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.98" cx="89" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.77" cx="105" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.63" cx="121" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.62" cx="137" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.79" cx="153" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="169" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.65" cx="185" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.56" cx="201" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="217" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.2" cx="233" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.14" cx="249" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.73" cx="265" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.93" cx="281" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.26" cx="297" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.67" cx="313" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.36" cx="329" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.32" cx="345" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.78" cx="361" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.53" cx="377" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.49" cx="393" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="409" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="425" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="441" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.76" cx="457" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.75" cx="473" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.11" cx="489" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.41" cx="505" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.43" cx="521" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.47" cx="537" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.21" cx="553" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.38" cx="569" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.72" cx="585" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.7" cx="601" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.27" cx="617" cy="248" r="4" fill="#E8CEF3" />
          <circle opacity="0.33" cx="633" cy="248" r="4" fill="#E8CEF3" />
        </g>
        <g filter="url(#filter0_ddd_905_4283)">
          <rect
            x="281.5"
            y="87.5"
            width="79"
            height="79"
            rx="13"
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x="281"
            y="87"
            width="80"
            height="80"
            rx="13.5"
            stroke="#E9D1F4"
            shapeRendering="crispEdges"
          />
          <g clipPath="url(#clip1_905_4283)">
            <path
              d="M306.604 118.333H299.729C296.564 118.333 294 115.769 294 112.604V105.729C294 102.564 296.564 100 299.729 100H306.604C309.768 100 312.333 102.564 312.333 105.729V112.604C312.333 115.769 309.768 118.333 306.604 118.333ZM306.604 141.25H299.729C296.564 141.25 294 138.686 294 135.521V128.646C294 125.481 296.564 122.917 299.729 122.917H306.604C309.768 122.917 312.333 125.481 312.333 128.646V135.521C312.333 138.686 309.768 141.25 306.604 141.25ZM329.519 100H322.645C319.48 100 316.916 102.564 316.916 105.729V112.604C316.916 115.769 319.48 118.333 322.645 118.333H329.519C332.684 118.333 335.248 115.769 335.248 112.604V105.729C335.248 102.564 332.684 100 329.519 100ZM328.374 110.312C328.374 110.945 327.86 111.458 327.228 111.458H324.936C324.304 111.458 323.79 110.945 323.79 110.312V108.021C323.79 107.388 324.304 106.875 324.936 106.875H327.228C327.86 106.875 328.374 107.388 328.374 108.021V110.312ZM328.374 127.745C328.374 125.463 326.813 123.345 324.56 122.979C321.689 122.511 319.207 124.716 319.207 127.5V147.706C316.742 145.675 314.37 143.691 314.292 143.617C312.179 141.644 308.854 141.754 306.879 143.867C304.901 145.982 305.002 149.303 307.103 151.269L311.276 155H349V153.641C349 148.932 346.117 144.701 341.733 142.978L328.376 137.725V127.745H328.374Z"
              fill="#9753B7"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddd_905_4283"
          x="260.5"
          y="76.5"
          width="121"
          height="121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_905_4283"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_905_4283"
            result="effect2_dropShadow_905_4283"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_905_4283"
            result="effect3_dropShadow_905_4283"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_905_4283"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_905_4283"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(325.46 128) rotate(90) scale(103.5 358.339)"
        >
          <stop stopColor="#737373" stopOpacity="0" />
          <stop offset="0.215" stopColor="#D9D9D9" />
          <stop offset="0.607466" stopColor="#D9D9D9" />
          <stop offset="0.972209" stopColor="#737373" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_905_4283">
          <rect width="642" height="254" rx="13" fill="white" />
        </clipPath>
        <clipPath id="clip1_905_4283">
          <rect
            width="55"
            height="55"
            fill="white"
            transform="translate(293.5 99.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
